export default "__VITE_ASSET__QLVnbz62__"